import { ApolloError } from '@apollo/client';
import { GraphQLError, GraphQLErrorExtensions } from 'graphql';

export enum GraphQLErrorTypes {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  BAD_GATEWAY = 'BAD_GATEWAY',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
}

export interface ErrorObject {
  message: string;
  code: GraphQLErrorTypes;
}

const extractError = (error: unknown, errorType: GraphQLErrorTypes): GraphQLError | undefined => {
  if (error instanceof ApolloError) {
    return error.graphQLErrors.find((e) => e.extensions?.code === errorType);
  }
  return undefined;
};

export const getGraphQLError = (error: unknown): ErrorObject | undefined => {
  const checkingErrors: GraphQLErrorTypes[] = Object.values(GraphQLErrorTypes);

  if (error instanceof ApolloError) {
    for (let i = 0; i < checkingErrors.length; i += 1) {
      const graphQLError = extractError(error, checkingErrors[i]);
      if (graphQLError) {
        return {
          message: graphQLError.message,
          code: checkingErrors[i],
        };
      }
    }
  }

  return undefined;
};
